import React, { useState, useEffect } from 'react'
import moment from 'moment'
import {
    StyledCalendarWrapper,
    StyledCalendar,
    StyledCalendarHeader,
    StyledCalendarBody,
    StyledCalendarMonth,
    StyledCalendarDays,
    StyledCalendarDay,
    StyledCalendarButtons,
    StyledCalendarButton,
    StyledCalendarDayName,
    StyledCalendarDayNumber,
    StyledIcon,
    StyledCalendarContent
} from './styled'

function Calendar({ days, content, fullContent, scrollContent }) {
    const [selectedDay, setDay] = useState(days[days.length - 1]);
    const [offsetDays, setOffsetDays] = useState(3);

    useEffect(() => {
        if (days) {
            setOffsetDays(days.length > 4 ? 3 : days.length - 1)
            setDay(days[days.length - 1])
        }
    }, [days])



    const getMonthName = () => {
        const indexSelctedDay = days.indexOf(selectedDay)
        const firstDay = days[indexSelctedDay - offsetDays]
        if (firstDay === undefined || indexSelctedDay < 0) {
            return ''
        }
        if (firstDay.month === selectedDay.month) {
            return selectedDay.month
        } else {
            return `${firstDay.month} / ${selectedDay.month}`
        }
    }

    let renderedDays = null;

    const getDays = () => {
        if ([...days].indexOf(selectedDay) > 2) {
            renderedDays = [...days].reverse().slice([...days].reverse().indexOf(selectedDay), [...days].reverse().indexOf(selectedDay) + 4).reverse()
        } else {
            renderedDays = [...days].slice(0, 4);
        };

        return renderedDays.map(day => (
            <StyledCalendarDay key={day.stamp} today={day.day === moment().format("DD")}>
                <StyledCalendarDayName>
                    {day.name}
                </StyledCalendarDayName>
                <StyledCalendarDayNumber>
                    {day.day}
                </StyledCalendarDayNumber>
            </StyledCalendarDay>
        ))
    }

    const handleChangeDay = direction => {
        if (direction === "prev") {
            if ([...days].indexOf(selectedDay) === offsetDays) return;
            setDay(days[[...days].indexOf(selectedDay) - 1])
        } else if (direction === "next") {
            if ([...days].indexOf(selectedDay) === days.length - 1) return;
            setDay(days[[...days].indexOf(selectedDay) + 1])
        }
    }

    return (
        <StyledCalendar>
            <StyledCalendarHeader fullContent={fullContent}>
                <StyledCalendarMonth>
                    {getMonthName()}
                </StyledCalendarMonth>
            </StyledCalendarHeader>
            <StyledCalendarBody fullContent={fullContent}>
                <StyledCalendarDays>
                    {getDays()}
                </StyledCalendarDays>
                <StyledCalendarButtons>
                    <StyledCalendarButton onClick={() => handleChangeDay('prev')}>
                        <StyledIcon name="arrow" direction="left" disabled={[...days].indexOf(selectedDay) === offsetDays} />
                    </StyledCalendarButton>
                    <StyledCalendarButton onClick={() => handleChangeDay('next')} >
                        <StyledIcon name="arrow" direction="right" disabled={[...days].indexOf(selectedDay) === days.length - 1} />
                    </StyledCalendarButton>
                </StyledCalendarButtons>
            </StyledCalendarBody>
            <StyledCalendarContent fullContent={fullContent} scrollContent={scrollContent}>
                {
                    content && content(renderedDays)
                }
            </StyledCalendarContent>
        </StyledCalendar>
    )
}

export const CalendarWrapper = ({ children }) => {
    return (
        <StyledCalendarWrapper>
            {children}
        </StyledCalendarWrapper>
    )
}

Calendar.defaultProps = {
    scrollContent: false
}

export default Calendar
